import React from 'react';
import { useState } from 'react';
import { useStyles } from './TaskTypeDropdown.styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpdIcon from '@material-ui/icons/ArrowDropUp';
import { useLayoutContext } from '../../../Context/Layout.context';
import TooltipOne from '../../TooltipOne/TooltipOne.component';

export type TaskTypeFilterValue = 'downloaded' | 'notAssessed';
interface TaskTypeDropdownProps {
  taskTypeFilter: TaskTypeFilterValue;
  onSelect?: (value: TaskTypeFilterValue) => void;
}

const TaskTypeDropdown: React.FC<TaskTypeDropdownProps> = (props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const classes = useStyles();
  const open = Boolean(anchorEl);

  const { isAnyDropdownOpen } = useLayoutContext();

  const handleClickSelect = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
    isAnyDropdownOpen.current = true;
  };

  const handleCloseSelect = () => {
    setAnchorEl(null);
    isAnyDropdownOpen.current = false;
  };

  const onMenuItemClick = (value: TaskTypeFilterValue) => {
    props.onSelect && props.onSelect(value);
    handleCloseSelect();
  };

  const arrow = open ? <ArrowDropUpdIcon /> : <ArrowDropDownIcon />;

  return (
    <div>
      <div onClick={handleClickSelect} aria-controls="TaskType-menu" aria-haspopup="true" className={classes.dropdown}>
        Typ zadania: {props.taskTypeFilter === 'downloaded' ? 'Pobrane' : 'Nieocenione'}
        <TooltipOne title={props.taskTypeFilter === 'downloaded' ? 'Typ zadania: Pobrane' : 'Typ zadania: Nieocenione'} placement="top">
          <span tabIndex={0}>{arrow}</span>
        </TooltipOne>
      </div>
      <Menu
        className={classes.selectList}
        id="TaskType-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleCloseSelect}
      >
        <MenuItem disableRipple onClick={() => onMenuItemClick('downloaded')} className={classes.dropdownElement}>
          Pobrane
        </MenuItem>
        <MenuItem disableRipple onClick={() => onMenuItemClick('notAssessed')} className={classes.dropdownElement}>
          Nieocenione
        </MenuItem>
      </Menu>
    </div>
  );
};

export default TaskTypeDropdown;
